import { render, staticRenderFns } from "./NewRegistrationComplete.vue?vue&type=template&id=43795db4&scoped=true&"
import script from "./NewRegistrationComplete.vue?vue&type=script&lang=js&"
export * from "./NewRegistrationComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43795db4",
  null
  
)

export default component.exports